import type { OverlayProps } from '@react-types/overlays';
import type { DOMRef } from '@react-types/shared';
import React, { forwardRef, useCallback, useState } from 'react';
import ReactDOM from 'react-dom';
import { OpenTransition } from '../open-transition';

const Overlay = (props: OverlayProps, ref: DOMRef) => {
  let { children, isOpen, container, onEnter, onEntering, onEntered, onExit, onExiting, onExited } =
    props;
  let [exited, setExited] = useState(!isOpen);

  let handleEntered = useCallback(() => {
    setExited(false);
    if (onEntered) {
      onEntered();
    }
  }, [onEntered]);

  let handleExited = useCallback(() => {
    setExited(true);
    if (onExited) {
      onExited();
    }
  }, [onExited]);

  let mountOverlay = isOpen || !exited;
  if (!mountOverlay) {
    return null;
  }

  let contents = (
    <OpenTransition
      in={isOpen}
      appear
      onExit={onExit}
      onExiting={onExiting}
      onExited={handleExited}
      onEnter={onEnter}
      onEntering={onEntering}
      onEntered={handleEntered}
    >
      {children}
    </OpenTransition>
  );

  return ReactDOM.createPortal(contents, container || document.body);
};

let _Overlay = forwardRef(Overlay);
export { _Overlay as Overlay };
